import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {
  buttonWrapper,
  helpWrapper,
  invertedText,
  helpText,
  helpIcon
} from './trigger-button.module.scss'

type Props = {
  text: string
  onClick: () => void
  invertColors: boolean
}

export function TriggerButton({invertColors, text, onClick}: Props) {
  return (
    <Button style="link" className={buttonWrapper} onClick={onClick}>
      <Flex alignItems="center" className={helpWrapper}>
        <FontAwesomeIcon icon={faQuestionCircle} className={helpIcon} inverse={invertColors} />
        <Text
          style="subtitle-2"
          htmlElement="span"
          className={addMaybeClassName(helpText, invertColors ? invertedText : null)}
        >
          {text}
        </Text>
      </Flex>
    </Button>
  )
}
